<!--
 * @description:
 * @author: Jason Wong
 * @since: 2022-05-23 10:56:10
-->
<template>
  <div class="component__notice--item" @click="handleNoticeClicked">
    <table style="width: 100%">
      <tr>
        <td rowspan="2" style="width: 24px">
          <div class="flex-center" style="height: 40px">
            <div :class="['read-symbol', !data.hasRead ? 'new' : null]"></div>
          </div>
        </td>
        <td rowspan="2" style="width: 48px">
          <div class="sender-image" style="margin-top: 6px">
            <img :src="data.senderPortrait" />
          </div>
        </td>
        <td
          :class="`txt_msg ${
            data.source === MESSAGE_SOURCE.system ? 'v-center' : null
          }`"
          v-html="data.message"
        ></td>
        <td
          :class="`color-super-info ${
            data.source === MESSAGE_SOURCE.system ? 'v-center' : null
          }`"
          style="width: 112px"
        >
          {{ Y_M_D_H_m(data.time) }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { Y_M_D_H_m } from "@/utils/dateUtils";
import { MESSAGE_SOURCE } from "../data";
export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      MESSAGE_SOURCE,
    };
  },
  methods: {
    Y_M_D_H_m,
    handleNoticeClicked() {
      this.$emit("readed", this.data);
    },
  },
};
</script>

<style lang="scss">
.component__notice--item {
  color: #606266;
  font-size: 12px;
  padding: 0 12px;

  .read-symbol {
    width: 8px;
    height: 8px;
    border-radius: 100%;

    &.new {
      background: #f56c6c;
    }
  }

  .sender-image {
    border-radius: 100%;
    overflow: hidden;
    width: 32px;
    height: 32px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  table {
    width: 100%;
    table-layout: fixed;
  }
  td {
    padding: 8px 3px;
    vertical-align: top;
    line-height: 18px;

    &.v-center {
      vertical-align: middle;
    }
  }

  .txt_msg {
    padding-right: 12px;
  }

  jump,
  a,
  retry-download {
    text-decoration: underline;
    color: #409eff;
    cursor: pointer;
    border-bottom: 0;
  }
}
</style>
